<template>
	<div class="layer-project" data-project-name="ing-life">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						ING Life <span class="ib">Mobile Center</span>
					</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						모바일 통합 영업지원시스템은 2017년 보험사 디지털화 사업 중 가장
						주목할 만한 사업으로 업계에서 관심이 매우 높았고, 특히 사용자의
						편의성을 위해 UI/UX에 집중한 프로젝트입니다. <br />설계사(FA),
						대리점(GA), 방카(BA)의 각 영업채널별로 운영되던 기존
						영업지원시스템을 통합하고, 웹과 모바일에서 동일한 사용자 경험을
						제공할 수 있도록 최적화한 디자인입니다.
					</p>
					<div class="project-overview-diagram clfix">
						<ul class="diagram01">
							<li class="item01">Brand <br />Identity</li>
							<li class="item02">UI/UX Design</li>
							<li class="item03">ING life</li>
						</ul>
						<ul class="diagram02">
							<li class="item04">ING Mobile <br />Center <em>Identity</em></li>
						</ul>
					</div>
				</div>
			</section>
			<!-- Details [e] -->

			<section class="section section01 full">
				<div class="inner-section">
					<div class="app-info-top clfix">
						<div class="app-info">
							<strong class="project-subtit">App</strong>
							<div class="app-text">
								부가적인 정보를 걷어내고 간결한 UI로 쉽게 구성하고, 흥미를
								유발할 수 있는 요소 및 인터렉션을 유도하여
								<span class="ib">심플한 구성으로</span> 쉽게 인지할 수 있도록
								하였습니다.
							</div>
						</div>
						<div class="main-img clfix">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ing-life/app-main-img01@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ing-life/app-main-img02@m.png"
								/>
							</div>
						</div>
					</div>
					<div class="sub-img clfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ing-life/app-sub-img01@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ing-life/app-sub-img02@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ing-life/app-sub-img03@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ing-life/app-sub-img04@m.png"
							/>
						</div>
					</div>
					<div class="text">
						사용자의 시선을 고려한 콘텐츠 순으로 구성하였습니다.<br />카드블록
						방식으로 주요정보를 상단에 배치하고
						<span class="ib">메뉴별 컬러를 선정하여</span> 각 메뉴에 대한
						이해도를 높이고, 개인화 영역 강조하였습니다.
					</div>
				</div>
			</section>

			<section class="section section02">
				<div class="inner-section">
					<div class="point-color-area">
						<ul>
							<li class="item01">ING <br />Orange<span>#ff8800</span></li>
							<li class="item02">Yellow<span>#ffd200</span></li>
							<li class="item03">Mint<span>#8fd0d4</span></li>
							<li class="item04">Baby Purple<span>#bfb2e7</span></li>
						</ul>
					</div>
					<div class="point-bottom-area clfix">
						<div class="point-font-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ing-life/point-font-img@mt.png"
									data-break="mt-w"
								/>
							</div>
						</div>
						<div class="point-icon-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ing-life/point-icon-img@m.png"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">ING Life Mobile Center</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/ing-life/ci.png) 50% / auto 37.5px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ing-life/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ing-life/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ing-life/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 75px;
	}
}

/* Overview */
.project-overview {
	background-color: #ff7900;
	color: #fff;
}

.project-overview-diagram {
	margin-top: 25px;
}
.project-overview-diagram .diagram01:after {
	content: "";
	display: block;
	clear: both;
}
.project-overview-diagram li {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 138px;
	height: 138px;
	font-weight: 500;
	border: 1px solid #fff;
	border-radius: 50%;
	text-align: center;
}
.diagram01 {
	position: relative;
	display: flex;
	align-items: center;
	flex-flow: wrap row;
}
.diagram01:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 1px;
	height: 42px;
	background-color: #fff;
}
.diagram02 li {
	margin: 0 auto;
	font-size: 16px;
	line-height: 17px;
	background-color: #fff;
	color: #ff7900;
	text-transform: uppercase;
}
.diagram02 li em {
	margin-top: 4px;
	font-size: 15px;
	font-weight: 400;
	text-transform: none;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram {
		padding-top: 13px;
	}
	.diagram01 {
		justify-content: center;
		margin-bottom: 10px;
		padding-bottom: 33px;
	}
	.diagram01 li {
		margin: -13px -4px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		width: 632px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.project-overview-diagram li {
		width: 132px;
		height: 132px;
	}
	.diagram01 {
		float: left;
		padding-left: 4px;
		padding-right: 107px;
	}
	.diagram01:after {
		bottom: 50%;
		left: auto;
		right: 0;
		width: 87px;
		height: 1px;
	}
	.diagram01 li {
		margin: 0 -4px;
	}
	.diagram02 {
		float: right;
	}
	.diagram02 li {
		margin: auto;
		font-size: 15px;
	}
	.diagram02 li em {
		font-size: 14px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 130px;
	}
	.project-overview-diagram {
		width: 100%;
		margin-top: 50px;
	}
	.project-overview-diagram li {
		width: 246px;
		height: 246px;
		font-size: 20px;
		border-width: 2px;
	}
	.diagram01 {
		padding-left: 7px;
		padding-right: 228px;
	}
	.diagram01:after {
		bottom: calc(50% - 1px);
		width: 162px;
		height: 2px;
	}
	.diagram01 li {
		margin: 0 -7px;
	}
	.diagram02 li {
		margin: auto;
		font-size: 28px;
		line-height: 30px;
	}
	.diagram02 li em {
		font-size: 24px;
	}
}

.section01 {
	position: relative;
}
.section01:before {
	content: "";
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: calc(100vw * (1147 / 640) + 180px);
	background-color: #a4dadc;
}
.section01 .inner-section {
	position: relative;
}
.section01 .project-subtit {
	text-transform: uppercase;
}
.app-info-top {
	width: 100%;
	min-width: 320px;
	max-width: 1240px;
	margin: 0 auto;
	margin-bottom: 60px;
	padding: 0 15px;
}
.app-text {
	color: #666;
	line-height: 22px;
	letter-spacing: -0.05em;
}
.app-info {
	margin-bottom: 25px;
	word-break: keep-all;
}
.main-img .img {
	float: left;
	width: 41.875vw;
}
.main-img .img + .img {
	float: right;
	margin-top: 45px;
}
.main-img img {
	border-radius: 13% 12% / 5% 6%;
	box-shadow: 0 32px 25px rgba(0, 0, 0, 0.35);
	background-color: #000;
}
.sub-img {
	margin-bottom: 40px;
	padding: 0 15px;
}
.sub-img .img {
	float: left;
	width: 42.03125vw;
}
.sub-img img {
	box-shadow: 0 8px 18px rgba(0, 0, 0, 0.17);
}
.section01 .text {
	color: #2b2b2b;
	letter-spacing: -0.05em;
	word-break: keep-all;
}

@media screen and (max-width: 711px) {
	.sub-img .img:nth-child(even) {
		float: right;
	}
	.sub-img .img:nth-child(n + 3) {
		margin-top: 22px;
	}
	.section01 .text {
		height: 105px;
		padding: 0 15px;
	}
}
@media screen and (min-width: 712px) {
	.section01:before {
		height: calc(100vw * (725 / 1424) + 60px);
	}
	.section01 .app-info-top {
		margin-bottom: 87px;
		padding: 0 40px;
		padding-top: 20px;
	}
	.section01 .app-info-top:after {
		content: "";
		display: block;
		clear: both;
	}
	.app-info {
		float: left;
		width: 29.4943vw;
		padding-top: 40px;
	}
	.main-img {
		float: right;
		width: 48.3146vw;
	}
	.main-img .img {
		width: 22.0505vw;
	}
	.main-img .img + .img {
		margin-top: 53px;
		margin-left: 30px;
	}
	.sub-img {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		padding: 0 40px;
	}
	.sub-img:after {
		content: none;
	}
	.sub-img .img {
		width: 19.6629vw;
	}
	.sub-img .img + .img {
		margin-left: 0;
	}
	.section01 .text {
		position: absolute;
		bottom: 0;
		left: 51.5vw;
		padding-right: 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section01:before {
		height: 852px;
	}
	.section01 .app-info-top {
		margin-bottom: 206px;
		padding-top: 72px;
	}
	.app-info {
		width: 315px;
		padding-top: 34px;
	}
	.main-img {
		width: 765px;
	}
	.main-img .img {
		width: 350px;
	}
	.main-img .img + .img {
		margin-top: 116px;
		margin-left: 65px;
	}
	.main-img img {
		border-radius: 45px;
		box-shadow: 0 65px 50px rgba(0, 0, 0, 0.35);
	}
	.sub-img {
		max-width: 1440px;
		margin: 0 auto;
		margin-bottom: 130px;
		padding: 0;
	}
	.sub-img .img {
		width: 310px;
	}
	.sub-img img {
		box-shadow: 0 16px 35px rgba(0, 0, 0, 0.17);
	}
	.section01 .text {
		width: 460px;
	}
}

.section02 {
	background-color: #ededed;
}
.point-color-area {
	margin-bottom: 40px;
}
.point-color-area ul {
	width: 205px;
	margin: 0 auto;
}
.point-color-area ul:after {
	content: "";
	display: block;
	clear: both;
}
.point-color-area ul li {
	position: relative;
	float: left;
	width: 100px;
	height: 100px;
	padding: 20px 10px;
	font-size: 13px;
	font-weight: 600;
	line-height: 16px;
	color: #fff;
	letter-spacing: 0;
}
.point-color-area ul li span {
	position: absolute;
	left: 10px;
	bottom: 20px;
	font-size: 12px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.5);
}
.point-color-area ul li:nth-child(1) {
	background-color: #ff8800;
}
.point-color-area ul li:nth-child(2) {
	background-color: #ffd200;
	color: #000;
}
.point-color-area ul li:nth-child(2) span {
	color: rgba(0, 0, 0, 0.5);
}
.point-color-area ul li:nth-child(3) {
	background-color: #8fd0d4;
}
.point-color-area ul li:nth-child(4) {
	background-color: #bfb2e7;
}
.point-font-area .img {
	width: 79.84375vw;
}

@media screen and (max-width: 711px) {
	.point-color-area ul li:nth-child(2n + 2) {
		margin-left: 5px;
	}
	.point-color-area ul li:nth-child(n + 3) {
		margin-top: 5px;
	}
	.point-font-area {
		margin-bottom: 40px;
	}
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.point-color-area {
		margin-bottom: 56px;
	}
	.point-color-area ul {
		width: 415px;
	}
	.point-color-area ul li + li {
		margin-left: 5px;
	}
	.point-bottom-area > div {
		float: left;
		width: 50%;
	}
	.point-font-area .img {
		width: 35.8848vw;
	}
	.point-icon-area .img {
		float: right;
		width: 40.7303vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		padding-top: 100px;
		padding-bottom: 100px;
	}
	.point-color-area ul {
		width: 790px;
		margin-bottom: 127px;
	}
	.point-color-area ul li {
		width: 190px;
		height: 190px;
		padding: 30px;
		font-size: 22px;
		line-height: 26px;
	}
	.point-color-area ul li span {
		left: 30px;
		bottom: 30px;
		font-size: 20px;
	}
	.point-color-area ul li + li {
		margin-left: 10px;
	}
	.point-font-area .img {
		width: 487px;
	}
	.point-icon-area .img {
		width: 647px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/ing-life.vue